import React from "react";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import "./index.scss";

export const PagePagination = ({
  totalItems,
  currentPage,
  pageSize,
  onPageChange,
  loading,
}) => {
  return (
    <Pagination
      className="pagination-style mt-3"
      showTitle={false}
      onChange={onPageChange}
      total={totalItems}
      current={currentPage}
      pageSize={pageSize}
      hideOnSinglePage={true}
      prevIcon={<i className="bi bi-arrow-left"></i>}
      nextIcon={<i className="bi bi-arrow-right"></i>}
      disabled={loading}
    />
  );
};

export const PageShowTotal = ({
  totalItems,
  currentPage,
  pageSize
}) => {
  return (
    <Pagination
      className="pagination-style paginate-item-none text-end"
      showTotal={(total, range) => `(Showing ${range[0]} - ${range[1]} itineraries of ${total} itineraries)`}
      total={totalItems}
      current={currentPage}
      pageSize={pageSize}
    />
  );
};

